import { RestaurantTableDTO } from '../../../../types/restaurant/RestaurantTableTypes';
import TableCard from './TableCard';

interface TableGridProps {
  tables: RestaurantTableDTO[];
  onEdit: (table: RestaurantTableDTO) => void;
  onStatusChange: Parameters<typeof TableCard>[0]['onStatusChange'];
  onActiveChange: Parameters<typeof TableCard>[0]['onActiveChange'];
}

const TableGrid = ({
  tables,
  onEdit,
  onStatusChange,
  onActiveChange,
}: TableGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:hidden">
      {tables.map((table) => (
        <TableCard
          key={table.id}
          table={table}
          onEdit={onEdit}
          onStatusChange={onStatusChange}
          onActiveChange={onActiveChange}
        />
      ))}
    </div>
  );
};

export default TableGrid;
